import { Component, OnInit } from '@angular/core';
import { GenericRelatorioComponent } from '../generic-relatorio.component';
import { Breadcrumb } from 'src/app/shared/components';
import { RelatorioService } from '../relatorio.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BeneficiariaService } from 'src/app/beneficiaria';
import { catchErr } from 'src/app/shared/utils';

interface PrefixoDashboard {
    prefixo: string;
    status: string;
    numeroDio: string;
    dataOperacao?: Date;
    contratoNome?: string;
}

@Component({
  selector: 'app-relatorio-dashboard-beneficiaria',
  templateUrl: './relatorio-dashboard-beneficiaria.component.html',
  styleUrls: ['./relatorio-dashboard-beneficiaria.component.css'],
  standalone: false
})
export class RelatorioDashboardBeneficiariaComponent extends GenericRelatorioComponent implements OnInit {
  
  breadcrumb: Breadcrumb[] = [
    { label: 'Início' },
    { label: 'Relatórios', route: '/relatorio' },
    { label: 'Dashboard Beneficiária' },
  ]

  prefixosAguardandoExecucao: PrefixoDashboard[] = [];
  prefixosCancelados: PrefixoDashboard[] = [];
  prefixosSemDios: string[] = [];

  constructor(
    private relatorioService: RelatorioService,
    protected override beneficiariaService: BeneficiariaService,
    protected override snackBar: MatSnackBar,
  ) {
    super(beneficiariaService, snackBar);
  }

  ngOnInit(): void {
    this.filters.dataExecucao = new Date();
    this.loadBeneficiarias();
  }

  loadBeneficiarias() {
    this.beneficiariaService.getAll().subscribe({
      next: (res) => {
        this.beneficiarias = res.data as any[];
      },
      error: (err) => catchErr(err, this.snackBar)
    });
  }

  search() {
    if (!this.filters.beneficiaria) {
      this.snackBar.open('Selecione uma beneficiária', '✕', { panelClass: ['warning'] });
      return;
    }

    if (!this.filters.dataOperacao) {
      this.snackBar.open('Selecione uma data', '✕', { panelClass: ['warning'] });
      return;
    }

    this.loading = true;
    
    const beneficiariaId = (this.filters.beneficiaria as any)?.id || (this.filters.beneficiaria as any);
    const dataOperacao = this.filters.dataOperacao as Date;
    
    // Buscar todos os prefixos com DIOs
    this.relatorioService.getRelatorioDashboardBeneficiaria(beneficiariaId, dataOperacao).subscribe({
      next: (res: any) => {        
        const dados = Array.isArray(res) ? res : (res.data || []);
        this.prefixosAguardandoExecucao = dados.filter((p: any) => p.status === 'AGUARDANDO_EXECUCAO');
        this.prefixosCancelados = dados.filter((p: any) => p.status === 'CANCELADA');
      },
      error: (err) => catchErr(err, this.snackBar)
    });

    // Buscar prefixos sem DIOs abertos
    this.relatorioService.getRelatorioPrefixosSemDio(beneficiariaId, dataOperacao).subscribe({
      next: (res) => {
        this.prefixosSemDios = res;
      },
      error: (err) => catchErr(err, this.snackBar)
    }).add(() => this.loading = false);
  }

}
